import { render, staticRenderFns } from "./core.vue?vue&type=template&id=22fd2143&scoped=true&"
var script = {}
import style0 from "./core.vue?vue&type=style&index=0&id=22fd2143&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd2143",
  null
  
)

export default component.exports